// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2VUKy","modalFooterButton":"ModalNotes_modalFooterButton__2JM6A"};